export const searchSettings = {
  base: {
    shouldSort: true,
    threshold: 0.5,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 1
  },
  superStrict: {
    shouldSort: true,
    threshold: 0,
    location: 0,
    distance: 0,
    maxPatternLength: 32,
    minMatchCharLength: 1
  },
  superFuzzy: {
    shouldSort: true,
    threshold: 0.8,
    location: 0,
    distance: 50,
    maxPatternLength: 32,
    minMatchCharLength: 1
  }
};


// WEBPACK FOOTER //
// ./src/utilities/fuseSearchSettings/index.js